let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("a3NGg")]).then(() => parcelRequire('gLfH6'));